import { SurveyResultModel } from './survey-result-model';

export interface GroupResultModel {
  groupName: string;
  others: SurveyResultModel;
  numberOfCompleteResponses: number;
  respondentNames: string;
  respondentNamesList: string[];
}
